import { useContext } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../Firebase/firebase';
import { AuthContext } from '../ProviderAuth/AuthProvider';
import swal from 'sweetalert';

const useAuth = () => {
  const [authState, dispatch] = useContext(AuthContext);

  // Función para cerrar sesión
  const logout = async () => {
    try {
      const confirmLogout = await swal({
        title: "¿Cerrar sesión?",
        text: "¿Estás seguro que quieres cerrar tu sesión?",
        icon: "warning",
        buttons: ["Cancelar", "Cerrar sesión"],
        dangerMode: true
      });

      if (confirmLogout) {
        await signOut(auth);
        dispatch({ type: "resetAuth" });
        swal({
          title: "Sesión cerrada",
          text: "Has cerrado sesión exitosamente",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      swal({
        title: "Error",
        text: "Hubo un problema al cerrar la sesión",
        icon: "error"
      });
    }
  };

  // Función para verificar si el usuario está autenticado
  const isAuthenticated = () => {
    return authState?.user && authState?.estadoUsuario === 'activo';
  };

  // Función para verificar si la autenticación está cargando
  const isLoading = () => {
    return authState?.estadoUsuario === 'buscando' || authState?.loading;
  };

  // Función para obtener los datos del usuario
  const getUserData = () => {
    return {
      uid: authState?.user?.uid,
      email: authState?.user?.email,
      nombre: authState?.user?.displayName,
      estadoUsuario: authState?.estadoUsuario
    };
  };

  return {
    // Estados
    user: authState?.user,
    isAuthenticated: isAuthenticated(),
    isLoading: isLoading(),
    userStatus: authState?.estadoUsuario,
    error: authState?.error,

    // Funciones
    logout,
    getUserData,

    // Dispatch para casos especiales
    dispatch
  };
};

export default useAuth; 